import { render, staticRenderFns } from "./declare.vue?vue&type=template&id=08ad7b68&scoped=true&"
import script from "./declare.vue?vue&type=script&lang=js&"
export * from "./declare.vue?vue&type=script&lang=js&"
import style0 from "./declare.vue?vue&type=style&index=0&id=08ad7b68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad7b68",
  null
  
)

export default component.exports